import { LENGTHS } from "../../../../../config/Config";
import { convertCurrencyToSymbol } from "../../../../../utils/CommonUtils";
import classes from "./ParkingAmountItem.module.css";

const ParkingAmountItem = (props) => {
  const amount = props && props.finalPrice
    ? `${convertCurrencyToSymbol(props.currency)}${parseFloat(props.finalPrice.toFixed(LENGTHS.TO_FIXED_LENGTH))}`
    : "";

  return <span className={classes.amount}>{amount}</span>;
};

export default ParkingAmountItem;
